import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class AffiliateController extends Controller {
  loginClick() {
    triggerCustomEvent(events.affiliate.login_click);
  }

  joinNowClick() {
    triggerCustomEvent(events.affiliate.join_now_click);
  }

  becomeAffiliateClick() {
    triggerCustomEvent(events.affiliate.become_affiliate_click);
  }
}
